/* istanbul ignore file */

import {
  colors,
  cusorOverrideZoomInIcon,
  cusorOverrideZoomOutIcon,
  LOADING_SPINNER_CLASS,
} from '@noths/polaris-client-ribbons-design-system';
import {
  mediaQuery,
  minBreakpoints,
  pxToRem,
  shadowRight,
  shadowUp,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { styles as modalStyles } from 'src/components/molecules/Modal/';
import { ZOOM_PAN_CONTENT_CLASS, ZOOM_PAN_WRAPPER_CLASS } from '../constants';

const { spacing } = theme;

export const modalCloseButton = css`
  position: absolute;
  right: ${pxToRem(spacing.xxl)};
  top: ${pxToRem(spacing.xxl)};
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  background-color: ${colors.neutralWhite};
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &.focus-visible {
    outline: none;

    &:before {
      content: '';
      position: absolute;
      top: ${pxToRem(-4)};
      bottom: ${pxToRem(-4)};
      left: ${pxToRem(-4)};
      right: ${pxToRem(-4)};
      border-radius: 50%;
      border: ${colors.brandBluePrimary} ${pxToRem(2)} solid;
    }

    &:after {
      content: '';
      position: absolute;
      top: ${pxToRem(-6)};
      bottom: ${pxToRem(-6)};
      left: ${pxToRem(-6)};
      right: ${pxToRem(-6)};
      border-radius: 50%;
      border: ${colors.neutralLighter} ${pxToRem(2)} solid;
    }
  }
`;

export const fullScreenImage = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const imagesContainer = css`
  width: 100%;
  flex-grow: 1;
  position: relative;
`;

export const tabpanel = css`
  height: 100%;

  .${ZOOM_PAN_WRAPPER_CLASS}, .${ZOOM_PAN_CONTENT_CLASS} {
    height: 100%;
    width: 100%;
  }
`;

export const keyboardNavigationText = css`
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgb(255, 255, 255);
  border-radius: 0.625rem;
  padding: 6px 0.5rem;
  margin: 0px;
  font-size: 0.75rem;
  border: none;

  &[data-has-focus='false'] {
    clip: rect(0, 0, 0, 0);
  }
`;

export const zoomWrapper = css`
  width: 100%;
  height: 100%;

  &[data-has-zoomed='true'] {
    ${cusorOverrideZoomOutIcon}
  }
  &[data-has-zoomed='false'] {
    ${cusorOverrideZoomInIcon}
  }
`;

export const modalContentContainer = css`
  background-color: ${colors.neutralLight};
`;

export const thumbnails = css`
  width: 100%;
  padding: ${pxToRem(spacing.md)};
  background-color: ${colors.neutralWhite};
  z-index: 1;
  ${shadowUp}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      width: ${pxToRem(126)};
      ${shadowRight}
    `,
  )}
`;

export const fullViewContainer = css`
  ${modalStyles.modalViewport}
  display: flex;
  flex-direction: column-reverse;

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      flex-direction: row;
    `,
  )}
`;

export const loadingSpinner = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .${LOADING_SPINNER_CLASS} {
    width: ${pxToRem(spacing.xxxl)};
    height: ${pxToRem(spacing.xxxl)};
  }
`;
